import { render, staticRenderFns } from "./InfrastructureRoot.vue?vue&type=template&id=03430082"
import script from "./InfrastructureRoot.vue?vue&type=script&lang=ts"
export * from "./InfrastructureRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports